// extracted by mini-css-extract-plugin
export default {"activeSidebar":"wa-z","pageLayout":"xa-z","mainContent":"ya-z","columnLayout":"za-z","columnLayoutFill":"Aa-z","columnLayoutLast":"Ba-z"};